export default __webpack_public_path__ + "static/media/routineCreate.bed5f047.png";